<!--
 * @Author: wsx
 * @Date: 2022-01-14 10:26:06
 * @LastEditTime: 2022-06-13 12:03:18
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description: 街道
-->
<template>
  <el-dialog
    v-model="dialogVisible"
    title="巡防点列表"
    width="60vw"
    @close="close"
  >
    <el-form
      ref="formRef"
      :inline="true"
      :rules="rules"
      :model="tableParams"
      class="form-box"
    >
      <el-form-item label="巡点名称" prop="patrolmanName">
        <el-input
          v-model="tableParams.patrolmanName"
          placeholder="巡点名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="" prop="">
        <h-button type="primary" @click="refreshTable">查询</h-button>
      </el-form-item>
      <el-form-item label="" prop="">
        <el-badge :value="saveSelectRow.length" :max="99" class="item">
          <el-popover
            placement="bottom"
            width="400px"
            popper-class="popperPointClass"
            trigger="manual"
            v-model:visible="visiblePopover"
          >
            <template #reference>
              <h-button @click="addPointArr">已选点位</h-button>
            </template>
            <div
              class="popoverItem"
              v-for="item in saveSelectRow"
              :key="item.patrolmanId"
            >
              <span class="title">{{ item.patrolmanName }}</span>
              <div>
                <el-select
                  v-model="item.signPoint"
                  placeholder="不限"
                  style="width: 100px"
                >
                  <el-option
                    v-for="item in pointStatus"
                    :key="item"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <i
                  class="iconfont icon-shanchu"
                  @click="delSelectData(item)"
                ></i>
              </div>
            </div>
          </el-popover>
        </el-badge>
      </el-form-item>
      <el-form-item label="" prop="">
        <h-button @click="addPointMap">添加到地图</h-button>
      </el-form-item>
    </el-form>

    <h-table
      ref="tableRef"
      class="patrolPointTable"
      v-model:columns="columns"
      :method="regionPatrolmanList"
      :params="tableParams"
      @select="handleSelect"
    >
      <template #patrolmanCoordinate="{ row }">
        <span v-if="row.patrolmanCoordinate">
          {{ JSON.parse(row.patrolmanCoordinate).toString() }}
        </span>
      </template>
    </h-table>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watch,
  ref,
  watchEffect,
  nextTick,
  computed,
} from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import {
  userDetele,
  regionPatrolmanList,
  relationSelect,
} from "@/api/system/patrol";
import util from "@util/js";
export default defineComponent({
  name: "patrolPointTable",
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedPoint: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, context) {
    const state = reactive({
      dialogVisible: false,
      visiblePopover: false,
      tableParams: {
        patrolmanType: "2",
        regionId: "",
        patrolmanName: "",
      },
      columns: [
        { type: "selection", show: true },
        { type: "index", show: true },
        {
          label: "巡防名称",
          prop: "patrolmanName",
        },
        {
          label: "经纬度",
          slot: "patrolmanCoordinate",
          width: "400px",
        },
        {
          label: "区域",
          prop: "regionName",
        },
      ],
      pointStatus: [
        // {
        //   label: "不限",
        //   value: "null",
        // },
        {
          label: "非必巡",
          value: "0",
        },
        {
          label: "必巡",
          value: "1",
        },
      ],
      selectRow: [],
      saveSelectRow: [],
    });
    const tableRef = ref(null);
    const refData = toRefs(state);
    watchEffect(() => {
      state.dialogVisible = props.visible;
      state.saveSelectRow = props.selectedPoint;
    });
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    //批量添加
    const handleSelect = async (value) => {
      state.saveSelectRow = [...state.saveSelectRow, ...value];
      //去重
      state.saveSelectRow = state.saveSelectRow.filter(
        (element, index, self) => {
          return (
            self.findIndex((x) => x.patrolmanId === element.patrolmanId) ===
            index
          );
        }
      );
    };
    //批量添加
    const addPointArr = () => {
      state.visiblePopover = !state.visiblePopover;
    };
    //删除已选点位
    const delSelectData = async (val) => {
      state.saveSelectRow = state.saveSelectRow.filter((element) => {
        return element.patrolmanName !== val.patrolmanName;
      });
      if (state.saveSelectRow.length == 0) {
        state.visiblePopover = false;
      }
    };
    //批量添加到地图
    const addPointMap = () => {
      state.saveSelectRow.forEach((item) => {
        if (!item.signPoint) {
          item.signPoint = "0";
        }
        state.pointStatus.forEach((el) => {
          if (item.signPoint + "" == el.value) {
            item.signPointDict = el.label;
          }
        });
      });
      context.emit("addpatrolPoint", state.saveSelectRow);
      context.emit("update:selectedPoint", state.saveSelectRow);
      close();
    };
    //关闭回调
    const close = () => {
      state.visiblePopover = false;
      context.emit("update:visible", false);
    };
    return {
      ...refData,
      tableRef,
      refreshTable,
      close,
      regionPatrolmanList,
      handleSelect,
      addPointArr,
      delSelectData,
      addPointMap,
    };
  },
});
</script>
<style lang="scss" scoped>
.patrolPointTable {
  width: 100%;
  height: 65vh;
  display: flex;
  flex-direction: column;
  .organTransfer {
    height: 400px;
  }
}
</style>
<style lang="scss" >
.popperPointClass {
  max-height: 200px;
  overflow: auto;
  width: 270px;
  .popoverItem {
    @include flex-row-sb-c;

    .iconfont {
      margin-left: 8px;
      cursor: pointer;
    }
  }
}
</style>
